import { AppStateResponse } from '@herbjoy/apex-api-models';
import { IHttpService, IQService, IPromise, IRequestConfig } from 'angular';

/**
 * An enumeration of all apex site feature modules.
 */
export * from '../../enum/site-module'

/**
 * A service that gets site module data from the API.
 */
export class SiteModuleService {
    _appStates: AppStateResponse[];
    _loadingAppStates: IPromise<AppStateResponse[]>;
    constructor(private $http: IHttpService, private $q: IQService, private apexApiUrl: string) {
        'ngInject';
    }

    retrieveIcdModules() {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/icd-modules`
        }).then(response => response.data);
    }

    retrieveDivisionalModules() {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/divisional-modules`
        }).then(response => response.data);
    }

    retrieveAppStates() {
        if (this._appStates) {
            return this.$q.resolve(this._appStates);
        }
        if (this._loadingAppStates) {
            // Avoid making the request multiple times.
            return this._loadingAppStates;
        }
        this._loadingAppStates = this.$http<AppStateResponse[]>({
            method: "GET",
            url: `${this.apexApiUrl}/app/states`,
            disableApexAuthInterceptor: true
        } as IRequestConfig).then(response => {
            this._loadingAppStates = null;
            this._appStates = response.data;
            return this._appStates;
        });
        return this._loadingAppStates;
    }
}
